import { useTranslation } from "react-i18next";
import useCrudFilters from "../../../../../hooks/useCrudFilters";
import useCrudTable from "../../../../../hooks/useCrudTable";
import { useTranslatedColumns } from "../../../../general/modules/commons/tableTranslation/translatedColumns";
import { RouteTableColumns } from "../../domain/columns/RouteTableColumns";
import { routeSchema } from "../../domain/schema/routeSchema";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { Content } from "../../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../../general/modules/commons/content/contentHeader";
import { RouteTableFilters } from "../features/RouteTableFilters";

export const RoutesPage = () => {
  const { t } = useTranslation("common");
  const title = t("Routes");
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector((state) => state.auth.user);

  const crudFilters = useCrudFilters(
    {
      searchBy: "SearchByRootRoute",
      fields: {},
    },
    "routeFilter",
  );

  const translatedColumns = useTranslatedColumns(RouteTableColumns);

  const crud = useCrudTable({
    prefix: "routes",
    entity: "Route",
    addAction: "/route/add",
    columns: translatedColumns,
    schema: routeSchema,
    filters: crudFilters.filters,
    defaultSorting: [{ id: "date", desc: true }],
  });

  if (!currentUser || currentUser.role === "dealer-employee") {
    return (
      <Layout>
        <LayoutContent>
          <Content>
            <ContentHeader className={"mt-3"} title={t("Access denied")} />
            <p className={"mt-3"}>{t("You don't have access to this page")}</p>
          </Content>
        </LayoutContent>
      </Layout>
    );
  }

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{title}</BreadCrumbItem>
          </Breadcrumb>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={title} className={"mb-3"} />
          <RouteTableFilters {...crudFilters} />
          {crud.table}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
